import { FC } from 'react';
import { IconProps } from '../types';

const RedirectIcon: FC<IconProps> = ({
  width = 89,
  height = 45,
  margin = 0,
  padding = 0,
  cursor = 'default',
  handleClick,
  opacity = '1',
  direction = 'up',
  dataTestId = 'redirect-icon'
}) => {
  const directionRotation = {
    up: '0deg',
    right: '90deg',
    down: '180deg',
    left: '270deg'
  };
  return (
    <svg
      width={width}
      height={height}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid={dataTestId}
      data-direction={direction}
      onClick={handleClick}
      style={{ margin, padding, cursor, rotate: directionRotation[direction] }}
      viewBox='0 0 89 45'
    >
      <g data-testid='g-path' opacity={opacity}>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M88.2579 21.3009L68.2943 0.566194C67.9438 0.200939 67.4642 0.00170898 66.9624 0.00170898H46.9951C46.2573 0.00170898 45.5858 0.444443 45.3017 1.1233C45.0102 1.80216 45.1541 2.5917 45.6706 3.12298L64.3761 22.5553L45.6928 41.2423C45.1652 41.7699 45.0065 42.5632 45.2906 43.2531C45.5784 43.943 46.2536 44.3931 46.9951 44.3931H66.9624C67.4531 44.3931 67.9217 44.1976 68.2685 43.8471L88.2321 23.8835C88.9442 23.1751 88.9552 22.024 88.2579 21.3009Z'
          fill='#015F94'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M53.3195 21.3009L33.3522 0.566194C33.0017 0.200939 32.5221 0.00170898 32.024 0.00170898H17.0485C16.307 0.00170898 15.6392 0.444443 15.3514 1.1233C15.0599 1.80216 15.2075 2.5917 15.7203 3.12298L34.4295 22.5553L15.7462 41.2423C15.2186 41.7699 15.0562 42.5632 15.344 43.2531C15.6281 43.943 16.3033 44.3931 17.0485 44.3931H32.024C32.511 44.3931 32.9796 44.1976 33.3264 43.8471L53.2937 23.8835C54.0057 23.1751 54.0168 22.024 53.3195 21.3009Z'
          fill='#3992C6'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M23.368 21.301L3.40076 0.566261C2.69608 -0.167939 1.52284 -0.190076 0.792325 0.510919C0.0581251 1.22298 0.0359883 2.38885 0.740673 3.12305L19.4535 22.5554L0.766499 41.2387C0.0470564 41.9619 0.0470564 43.1277 0.766499 43.8472C1.12806 44.2087 1.60031 44.3895 2.07625 44.3895C2.54112 44.3895 3.01337 44.2087 3.37863 43.8472L23.3422 23.8836C24.058 23.1752 24.0654 22.0241 23.368 21.301Z'
          fill='#EC9F24'
        />
      </g>
    </svg>
  );
};

export default RedirectIcon;
